import store_prestation from "@/store/mods/clinique/prestations"
import mod_prestation from "@/store/mods/clinique/prestations.js"
import TypeFacturationChoix from '@/components/type-facturation-choix'

export default {
    name: 'm-acte',
    components: { TypeFacturationChoix },
    props: {
        user_id: Number,
        info_patient: Object,
        info_caissier: Object,
        refresh_state: Number,
        is_proforma: Boolean,
        proforma_id: Number,
        can_add_differential_computing: Object,
        format_ref_facture: String,
        selected_slug: String,
        patient_insurance_info: Object
    },
    data() {
        return {
            one_is_checked: [],
            save_loading: false,
            choice_is_empty: false,
            is_error: false,
            permission_is_denied: false,

            filter_acte: '',
            filtered_actes: [],
            selected_prestations: [],
            tarif_actes: [],

            is_loading: true,
            is_empty: false,

            // Type de facturation (normal / urgence), remis à normal à chaque ouverture (15/10/2026)
            type_facturation: 'normal'
        }
    },
    
    watch: {
        filter_acte() {
            this.filterActe()
        },

        one_is_checked() {
            this.choice_is_empty = false
        },

        type_facturation() {
            this.retirerSansPrix()
        },

        refresh_state() {
            if (this.selected_slug == 'acte') {
                this.type_facturation = 'normal'
                this.$store.dispatch('getTypesFacturationPrestation')
                this.fetchActes()
            }
        }
    },

    computed: {
        types_facturation_prestation() {
            return this.$store.getters['types_facturation_prestation']
        },
        
    },

    mounted() {
        
    },

    methods: {
        hadleUndefinedPrice(libelle) {
            if (this.type_facturation === 'urgence') {
                this.warningToast("Tarif urgence non configuré pour " + (libelle || "cet acte"))
                return
            }
            this.warningToast("Le prix de cet acte n'a pas été défini !")
        },

        /**
         * Prix de l'acte pour le type de facturation choisi (prix urgence NULL = non configuré)
         */
        prixSelonType(acte) {
            return Number((this.type_facturation === 'urgence') ? acte.prix_urgence : acte.prix)
        },

        /**
         * Changement de type : décocher les actes sans prix pour ce type
         */
        retirerSansPrix() {
            const sans_prix = this.one_is_checked.filter(acte => !(this.prixSelonType(acte) > 0))
            if (sans_prix.length == 0) {
                return
            }
            this.one_is_checked = this.one_is_checked.filter(acte => this.prixSelonType(acte) > 0)

            const motif = (this.type_facturation === 'urgence') ? 'Tarif urgence non configuré' : 'Prix non configuré'
            this.warningToast(motif + " pour " + sans_prix.map(acte => acte.nom).join(', ') + " (décoché(s))")
        },

        fetchActes() {
            this.is_loading = true
            store_prestation.getTarifActe('acte').then((tarif_actes) => {
                this.tarif_actes = tarif_actes
                this.filtered_actes = this.tarif_actes

                if (this.filtered_actes.length == 0) {
                    this.is_empty = true
                } else {
                    this.is_empty = false
                }
                this.is_loading = false
            }).catch(() => {
                this.is_loading = false
                this.is_error = true
            })
        },

        submit() {
            if (this.one_is_checked.length == 0) {
                this.choice_is_empty = true
                return;
            }
            this.one_is_checked = this.setPrestationUID(this.one_is_checked)

            let data = {
                user_id: this.user_id,
                patient_id: this.info_patient.id,
                prestations: this.one_is_checked.map(acte => Object.assign({}, acte, { type_facturation: this.type_facturation })),
                type_prestation: 'Acte',
                data_type: 'acte',
                proforma_id: this.proforma_id,
                is_proforma: this.is_proforma,
                can_add_differential_computing: this.can_add_differential_computing.response,
                can_set_pac: this.can_set_pac,
                info_caissier: this.info_caissier,
                info_patient: {
                    nom_patient: this.info_patient.nom,
                    sexe: this.formatSexeMetier(this.info_patient.sexe),
                    telephone: this.info_patient.telephone_mobile,
                    num_dossier: this.info_patient.num_dossier,
                    age: this.info_patient.age
                },
                format_ref_facture: this.format_ref_facture
            }

            this.save_loading = true
            mod_prestation.getTarifPrestation(data).then((response) => {
                // Urgence sans prix urgence configuré : jamais facturée, ni au prix normal
                const urgences_absentes = (response.prestations || []).filter(prestation => prestation.tarif_urgence_absent == 1)
                if (urgences_absentes.length > 0) {
                    this.save_loading = false
                    this.dangerToast("Tarif urgence non configuré pour " + urgences_absentes.map(prestation => prestation.libelle).join(', '))
                    return
                }

                data = Object.assign(data, response)
                data.duree_forfait_hospi_est_expire = this.patient_insurance_info.duree_forfait_hospi_est_expire

                this.$store.dispatch('saveVentePrestation', data).then((response) => {
                    if (response.success) {
                        this.successToast('Ajout effectué avec succès')
                        this.$emit('emitPrestation', response.fpro_id)

                        this.one_is_checked = []
                        this.$refs.fpro_acte.click()

                        if (response.fpro_id > 0) {
                            this.$router.push({ path: '/ventes/facture-proforma/'+response.fpro_id })
                        }
                    } else {
                        this.$refs.fpro_acte.click()
                        this.dangerToast(response.message)
                    }

                    this.save_loading = false
                }).catch((error) => {
                    this.save_loading = false
                    this.$refs.fpro_acte.click()
                    // Refus de la caisse (ex. 422 : tarif urgence non configuré) : afficher son message
                    this.dangerToast((error && error.response && error.response.data && error.response.data.message) || 'Une erreur est survenue lors de l\'enregistrement. Veuillez réessayer plus tard.')
                })
            }).catch(() => {
                this.save_loading = false
                this.$refs.fpro_acte.click()
                this.dangerToast('Une erreur est survenue lors du calcul des tarifs. Veuillez réessayer plus tard.')
            })
        },

        filterActe() {
            this.filtered_actes = [];

            if (this.filter_acte == '') {
                this.filtered_actes = this.tarif_actes
            } else {
                this.tarif_actes.forEach(acte => {
                    let cleaned_acte = this.removeAccents(acte.acte)
                    let cleaned_filter = this.removeAccents(this.filter_acte)

                    if (cleaned_acte.toLowerCase().includes(cleaned_filter.toLowerCase())) {
                        this.filtered_actes.push(acte)
                    }
                });
            }
        },
    }
}
